<template>
	<bsh-modal 
		titulo="Editar Cliente"
		tamanho="modal-lg"
		:name="name">
		<template v-slot:default>
	        <cliente-form
				:dados="dados" 
	        	:name="name" 
	        	:errors="errors">
	        </cliente-form>
	    </template>
	    <template v-slot:footer>
        	<button 
				ref="btnRequest"
        		type="button" 
        		class="btn btn-primary" 
        		@click="update">
        		Salvar
        	</button>
        </template>
    </bsh-modal>
</template>

<script>
	export default {
		data(){
			return {
				dados: [],
				name: 'update_cliente',
				errors: []
			}
		}, 
		created(){
			this.getDados();
		},
		methods: {
			update(){
				this.$btnFunctions.disableToggle(this.$refs.btnRequest, true)
	            axios.put(this.$url+'/api/adm/clientes/update/'+this.$route.params.id, (this.dados))
	            .then(response => {
	            	$('#'+this.name).modal('hide')
	            	this.$bshMessage.show(response.data.message, response.data.type)
	              	this.$emit('reload')
					this.$btnFunctions.disableToggle(this.$refs.btnRequest, false)
	            })
	            .catch(error => {
					this.errors = error.response.data.errors
					this.$btnFunctions.disableToggle(this.$refs.btnRequest, false)
				});
        	},
        	getDados(){
	            axios.get(this.$url+'/api/adm/clientes/show/'+this.$route.params.id)
	            .then(response => {
	            	this.dados = response.data.data
	            })
	            .catch(error => {
	            	console.log(error)
	            });
			}
		}
	}
</script>